import { Suspense } from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated() ? (
    <Suspense fallback={<div>Loading...</div>}>
      <Navigate to="/dashboard" replace />{" "}
    </Suspense>
  ) : (
    children
  );
};

export default PublicRoute;
